import campusIcon1 from "@/assets/images/education/campus-icon1.svg"
import campusIcon2 from "@/assets/images/education/campus-icon2.svg"
import campusIcon3 from "@/assets/images/education/campus-icon3.svg"
import React from "react"
import {Link} from "gatsby";

export const CAMPUS_DATA = {
  introductionText: {
    title: "校园人才生态",
    describe:
      "PingCAP 校园人才生态致力于整合国内外高校资源，深化产学研融合，赋能未来数据智能人才培养，完善人才成长路径，为 PingCAP 客户与合作伙伴提供优秀人才。",
  },
  educationValue: [
    {
      icon: campusIcon1,
      title: "赋能高校",
      describe: "依托技术积累和产业实践赋能教师，<br />助力信息技术新工科建设",
    },
    {
      icon: campusIcon2,
      title: "共育人才",
      describe:
        "聚焦数据库、大数据、人工智能等前沿技术领域，培养交叉复合型人才",
    },
    {
      icon: campusIcon3,
      title: "服务产业",
      describe: "培育人才，服务区域产业，<br />人才配套建设",
    },
  ],
  cooperationModelText: {
    title: "合作模式",
    model: [
      {
        title: "人才培养合作",
        describe:
          "通过课程改革、实验方案建设、大赛、线上线下训练营等项目激励学生学习动力，优化学生学习体验和效果。",
      },
      {
        title: "师资培训合作",
        describe:
          "PingCAP 通过教育部等权威机构开展师资培训，教材编写、课程制作和专业建设等活动共同提升教学师资力量。",
      },
    ],
  },
  cooperationFlow: {
    title: "合作流程",
    flow: [
      { describe: "了解 PingCAP 人才生态资源和特点" },
      { describe: <>结合学校需求，签署 <Link to={"/pingcap-alliance-of-universities"}>PingCAP 数据库学院计划</Link></> },
      { describe: "与 PingCAP 校园经理商讨具体合作内容" },
      { describe: "开展合作及后续跟踪" },
    ],
  },
  contactUs: {
    title: "与 PingCAP 一起，共建校园人才生态",
    btnList: [
      {
        name: "联系我们",
        link: "/contact",
      },
    ],
  },
}
